import { useCallback } from 'react'
import { ConversationChatDrawer } from '../../../components/chat/conversation-chat-drawer'
import { useViewActions } from '../../../view-atoms'
import type { ActionEditState } from '../../../atoms'

interface ActionChatDrawerProps {
  actionId: string
  chatId: string
  editState: ActionEditState | undefined
  open: boolean
  entranceSettled: boolean
  onDismiss: () => void
}

export function ActionChatDrawer({
  actionId,
  chatId,
  editState,
  open,
  entranceSettled,
  onDismiss,
}: ActionChatDrawerProps) {
  const { openView } = useViewActions()
  const handleStagedActionClick = useCallback(
    (clickedActionId: string) => {
      if (clickedActionId === actionId) {
        onDismiss()
        return
      }
      openView('action', { actionId: clickedActionId }, { sourceLabel: 'Action' })
    },
    [openView, actionId, onDismiss],
  )

  return (
    <ConversationChatDrawer
      chatId={chatId}
      open={open}
      entranceSettled={entranceSettled}
      isFreshSubmit={editState?.status === 'pending'}
      onDismiss={onDismiss}
      onStagedActionClick={handleStagedActionClick}
      sourceLabel="Action"
    />
  )
}
